import { createTheme } from '@mui/material/styles';

const modernTheme = createTheme({
  palette: {
    primary: {
      main: 'hsl(217, 91%, 60%)', // Match mobile app
      light: 'hsl(217, 91%, 70%)',
      dark: 'hsl(217, 91%, 50%)',
      contrastText: '#ffffff',
    },
    secondary: {
      main: 'hsl(220, 14%, 96%)',
      contrastText: 'hsl(220, 13%, 18%)',
    },
    background: {
      default: '#f8fafc', // Slight off-white background to make cards pop
      paper: '#ffffff',
    },
    text: {
      primary: 'hsl(220, 13%, 18%)', // Mobile foreground
      secondary: 'hsl(220, 9%, 46%)', // Mobile muted foreground
    },
    error: {
      main: 'hsl(0, 84%, 60%)', // Mobile destructive
    },
    divider: 'hsl(220, 13%, 91%)',
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 600, fontSize: '2rem' },
    h2: { fontWeight: 600, fontSize: '1.75rem' },
    h3: { fontWeight: 600, fontSize: '1.5rem' },
    h4: { fontWeight: 600, fontSize: '1.25rem' },
    h5: { fontWeight: 600, fontSize: '1.125rem' },
    h6: { fontWeight: 600, fontSize: '1rem' },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 500, color: 'hsl(220, 9%, 46%)' },
    body1: { fontSize: '0.875rem' }, // slightly smaller, SaaS minimal look
    body2: { fontSize: '0.8125rem', color: 'hsl(220, 9%, 46%)' },
    button: { textTransform: 'none', fontWeight: 500 },
  },
  shape: {
    borderRadius: 10, // Match mobile app radius
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          padding: '8px 16px',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: 'hsl(217, 91%, 55%)',
          },
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.05), 0 2px 4px -2px rgb(0 0 0 / 0.05)', // Tailwind shadow-sm/md
          border: '1px solid hsl(220, 13%, 91%)', // Mobile border
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        elevation1: {
          boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
          border: '1px solid hsl(220, 13%, 91%)',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
          padding: '16px',
          boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'hsl(220, 13%, 91%)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'hsl(217, 91%, 80%)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'hsl(217, 91%, 60%)',
            borderWidth: '1px',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'hsl(220, 9%, 46%)',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.54)',
          '&.Mui-checked': {
            color: 'hsl(217, 91%, 60%)',
          },
        },
      },
    },
  },
});

export default modernTheme;
